



















import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3,logoutPanel } from "@/components";
import { TbGoods,TbTransferOrder,TbShop } from '@/http';
import { warn } from 'console';
import calculate from '@/common/util/calculate';
import { Toast } from 'vant';
import { log } from 'util';
import newLodop from "@/common/util/newlodop";
@Component({
    components: {
        padHeadPanel3
    },
})
export default class chooseBlue extends Vue {
    public $refs: {
    };

    //判断是小票还是标签打印机
    printType = '';

    printtit = '';

    /**其他店铺库存 */
    show=false;

    //打印机设备
    deviceList=[];

    userInfo = {}

    connectName = '';

    /**上一页-判断返回 */
    from = "";
    /**判断是否有未打印的数据 */
    needPrint = "";

    created() {
        this.printType = this.$route.query.name;
        this.printtit = this.printType=='xp'?'小票打印机':'标签打印机';
        this.from =this.$route.query.from;
        this.needPrint =this.$route.query.needPrint;
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"))
    }
    async mounted(){
        // window['returnBluetoothlist'] = (val) => {
            this.returnBluetoothlist()
        // }
        // // window['finishBluetooth'] = (val) => {
            this.finishBluetooth()
        // }
    }
    goBacknew(){
        let type = this.printType=="xp"?2:1;
        let form = {
            name:this.connectName,
            type:type.toString(),
        }
        localStorage.setItem('blueInfo',JSON.stringify(form));
        if(this.from=='reail'){
            this.$router.go(-1)
        }else if(this.from=='addProduct'){
            this.$router.push(`/pad/product/index`);
        }else{
            this.$router.push(`/pad/setting/index?tag=pjsz`);
        }
    }
    // * 返回蓝牙列表
    returnBluetoothlist(bluetoothlist?){
        // let newBluetoothlist = bluetoothlist?bluetoothlist.split(','):[];
        // // newBluetoothlist = newBluetoothlist.filter(v=>v.toUpperCase().indexOf(this.form.model.toUpperCase())>-1);
        // this.deviceList = newBluetoothlist.map(v=>{
        //     return{
        //         name:v,
        //         value:''
        //     }
        // });  
        this.deviceList= []
        let LODOP = newLodop.getLodop("", "")
        let counter = LODOP.GET_PRINTER_COUNT() // 获取打印机个数
        for (let i = 0; i < counter; i++) {
            this.deviceList.push({  // 将打印机存入printerList数组中
                name: LODOP.GET_PRINTER_NAME(i),
                value: i
            })
        } 
        console.log('蓝牙看呀',this.deviceList)
    }
    /**连接蓝牙 */
    async createBLEConnection(e) {
        let type = this.printType=="xp"?2:1;
        let form = {
            name:e.name,
            type:type,
        }
        this.connectName = e.name;
        if(type==2){
            localStorage.setItem('receiptPrinterName',this.connectName);
        }else{
            localStorage.setItem('labelPrinterName',this.connectName);
        }
        
        // window.webkit.messageHandlers.connectBluetooth.postMessage(JSON.stringify(form));
        
        this.goBacknew();
    }
    finishBluetooth(val?){
        // if(val=='true'){
            let type = this.printType=="xp"?2:1;
            if(type==2){
                localStorage.setItem('receiptPrinterName',this.connectName);
            }else{
                localStorage.setItem('labelPrinterName',this.connectName);
            }

            // let form = {
            //     name:this.connectName,
            //     type:type.toString(),
            // }
            // window.webkit.messageHandlers.connectPrinter.postMessage(JSON.stringify(form))
           
        // }
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/chooseBlue.vue